import React from "react";
import { Box } from "@mui/material";

import RenderDate from "../../../Common/Date/RenderDate";
import RenderPerson from "../../../Common/Person/RenderPerson";
import RenderReportStatus from "../Report/RenderReportStatus";
import RenderSelfAssessment from "./RenderSelfAssessment";

const SurveyDetails = ({
    requester,
    areaOfWork = null,
    organisation = null,
    facilitator = null,
    report = null,
    startDate = null,
    endDate = null,
    selfAssessment = null,
    isFacilitator = false,
    isActive = false,
}) => {
    const displayJobRole = requester?.jobRole || "Not specified";
    const displayAreaOfWork = areaOfWork?.name || "Not specified";
    const displayOrganisation = organisation?.name || "Not specified";
    const displaySelfAssessment = selfAssessment?.isRequired;

    return (
        <Box className="flex-container">
            <dl className="row-data">
                <dt>Name</dt>
                <dd>
                    <RenderPerson person={requester} isRequired={isActive} />
                </dd>
            </dl>

            <dl className="row-data">
                <dt>Job role</dt>
                <dd>{displayJobRole}</dd>
            </dl>

            <dl className="row-data">
                <dt>Area of work</dt>
                <dd>{displayAreaOfWork}</dd>
            </dl>

            <dl className="row-data">
                <dt>Organisation</dt>
                <dd>{displayOrganisation}</dd>
            </dl>

            <dl className="row-data">
                <dt>Facilitator</dt>
                <dd>
                    <RenderPerson person={facilitator} isRequired={isActive} />
                </dd>
            </dl>

            <dl className="row-data">
                <dt>Start</dt>
                <dd>{!!startDate && <RenderDate date={startDate} />}</dd>
            </dl>

            <dl className="row-data">
                <dt>End</dt>
                <dd>
                    {!!endDate && (
                        <RenderDate date={endDate} colourise={isActive} />
                    )}
                </dd>
            </dl>

            {displaySelfAssessment && (
                <dl className="row-data">
                    <dt>Self assessment</dt>
                    <dd>
                        <RenderSelfAssessment selfAssessment={selfAssessment} />
                    </dd>
                </dl>
            )}

            <dl className="row-data">
                <dt>Report</dt>
                <dd>
                    <RenderReportStatus
                        report={report || ""}
                        isFacilitator={isFacilitator}
                    />
                </dd>
            </dl>
        </Box>
    );
};

export default React.memo(SurveyDetails);
